export const compareRoutes = (location, route) => {
  const pns = location.split('/')
  const nmps = route.split('/')
  if (pns.length !== nmps.length) return false
  let ret = true
  pns.forEach((item, index) => (ret = ret && (nmps[index][0] === ':' || item === nmps[index])))

  return pns.length === nmps.length && ret
}
